<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <h2 style="margin-left: 1rem;">
        Uredite odpis:
      </h2>
      <v-btn
        color="#0F998E"
        class="white--text"
        style="margin-right: 1rem;"
        @click="printAcceptanceForm"
      >
      Tiskaj
      <v-icon right dark>mdi-printer</v-icon>
      </v-btn>
    </v-row>

    <WriteoffFormForm
      ref="writeoffformform"
      :writeoffform="writeoffform"
      :skrij="true"
      @sprememba="spremeni"
      @save="save"
      @cancel="cancel"
    />

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv artikla
                </th>
                <th class="text-left">
                  Količina
                </th>
                <th class="text-left">
                  Merska enota
                </th>
                <th class="text-left">
                  Odpisna cena
                </th>
                <th class="text-left">
                  Odpisni znesek
                </th>
                <th class="text-left">
                  DDV %
                </th>
                <th class="text-left">
                  DDV vrednost
                </th>
                <th class="text-left">
                  Cena z DDV/MPC
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <WriteoffFormArticleRow
                v-for="(article, index) in localArticles"
                ref="acceptanceFormArticleRow"
                :key="index"
                :article="article"
                :articles="articles"
                @delete="deleteArticle(index)"
                @update="updateArticleRowInLocalArray(index, $event)"
              >
              </WriteoffFormArticleRow>

              <WriteoffFormArticleRow
                v-if="addingArticle"
                :articles="articles"
                @cancel="addingArticle = false"
                @save="addArticleRowToLocalArray"
              />
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="addingArticle = true"
        :disabled="addingArticle"
      >
        Dodaj postavko
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="false"
        @click="undoChanges"
      >
        Prekliči
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="!unsavedChanges"
        @click="doSaveWriteoffFormArticles"
      >
        Shrani
      </v-btn>
    </v-row>
    <v-row>
      <v-col class="mt-12"></v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import WriteoffFormForm from '@/components/WriteoffFormForm'
import WriteoffFormArticleRow from '@/components/WriteoffFormArticleRow'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import { siFloatToFloat } from '@/utils/number'

export default {
  components: {
    WriteoffFormForm,
    WriteoffFormArticleRow,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      localArticles: [],
      unsavedChanges: false,
      addingArticle: false,
      showWarningModal: false
    }
  },
  computed: {
    articles () {
      return objectToArray(this.$store.state.articles.inventoryItems)
    },
    writeoffform () {
      const accForm = this.$store.state.writeoffForms.items[this.id]
      if (!accForm) return accForm
      return {
        ...accForm,
        date: moment(accForm.date).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    ...mapActions('writeoffForms', ['loadItem', 'saveItem', 'articleMargin']),
    ...mapActions('articles', { saveArticle: 'saveItem', loadArticles: 'loadInventoryItems' }),
    ...mapActions('writeoffFormArticles', { saveWriteoffFormArticles: 'saveItems' }),
    handleFocusOut () {
      this.showWarningModal = true
    },
    printAcceptanceForm () {
      let routeData = this.$router.resolve({ name: 'MyCompanyWriteoffFormsPreview', params: { id: this.id } })
      window.open(routeData.href, '_blank')
    },
    spremeni () {
      this.unsavedChanges = !this.unsavedChanges
    },
    save ({ data }) {
      saveItem(data, 'MyCompanyWriteoffForms', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyWriteoffForms' })
    },
    doSaveWriteoffFormArticles () {
      this.saveWriteoffFormArticles({
        writeOffId: this.id,
        items: {
          articles: this.localArticles
        }
      })
        .then(response => {
          this.unsavedChanges = false
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$refs.writeoffformform.save()
        })
    },
    updateArticleRowInLocalArray (index, article) {
      this.localArticles[index] = article
      this.unsavedChanges = true
      this.setMarginForArticleOnIndex(article, index)
    },
    addArticleRowToLocalArray (article) {
      this.addingArticle = false
      article.saving = true
      this.localArticles.push(article)
      const index = this.localArticles.length - 1
      this.setMarginForArticleOnIndex(article, index)
      this.unsavedChanges = true
      this.$nextTick(() => {
        this.addingArticle = true
      })
      this.$refs.bottomOfThePage.scrollIntoView()
    },
    setMarginForArticleOnIndex (article, index) {
      this.getMargin(article)
        .then(marginData => {
          this.localArticles[index].margin = siFloatToFloat(marginData.percent)
          this.localArticles[index].marginValue = siFloatToFloat(marginData.value)
          this.$refs.acceptanceFormArticleRow[index].setStartingArticleFields(article)
          this.$refs.acceptanceFormArticleRow[index].stopSaving()
        })
        .catch(anErr => {
          this.localArticles[index].margin = null
          this.localArticles[index].marginValue = null
          this.$refs.acceptanceFormArticleRow[index].setStartingArticleFields(article)
          this.$refs.acceptanceFormArticleRow[index].stopSaving()
        })
    },
    async getMargin (article) {
      const articleData = await this.articleMargin({
        acceptanceFormId: this.id,
        params: {
          article: article.article,
          quantity: article.quantity,
          price: article.price,
          discount: article.discount
        }
      })
      return {
        value: articleData.margin,
        percent: articleData.margin_percent
      }
    },
    deleteArticle (index) {
      this.localArticles.splice(index, 1)
      const newArray = this.localArticles
      this.localArticles = []
      this.$nextTick(() => {
        this.localArticles = newArray
      })
      this.unsavedChanges = true
    },
    undoChanges () {
      this.loadItem(this.id)
        .then(response => {
          this.localArticles = []
          this.$nextTick(() => {
            this.localArticles = response.articles
          })
          this.unsavedChanges = false
          this.addingArticle = false
          if (this.$refs.acceptanceFormArticleRow) {
            this.$refs.acceptanceFormArticleRow.forEach((ref) => {
              ref.setStartingArticleFields()
              this.$router.go(-1)
            })
          } else {
            this.$router.push({ name: 'MyCompanyWriteoffForms' })
          }
        })
    }
  },
  created () {
    Promise.all([
      this.loadItem(this.id),
      this.loadArticles()
    ])
      .then(response => {
        this.localArticles = response[0].articles
        this.asyncDataStatus_fetched()
      })
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyWriteoffForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
